import { MessageCircle, Send } from "lucide-react";
import { waLink, tgLink } from "@/data/site";

export const FloatingButtons = () => {
  return (
    <div data-testid="floating-buttons" className="fixed bottom-5 right-5 z-50 flex flex-col gap-3">
      <a
        href={waLink("Hola, quiero información sobre BrothersPlus TV.")}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="float-whatsapp"
        aria-label="WhatsApp"
        className="grid place-items-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-[#25D366]/30 transition-transform duration-200 hover:scale-110 active:scale-95"
      >
        <MessageCircle className="w-6 h-6" />
      </a>
      <a
        href={tgLink()}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="float-telegram"
        aria-label="Telegram"
        className="grid place-items-center w-14 h-14 rounded-full bg-[#0088cc] text-white shadow-lg shadow-[#0088cc]/30 transition-transform duration-200 hover:scale-110 active:scale-95"
      >
        <Send className="w-6 h-6" />
      </a>
    </div>
  );
};
